import { Box, Divider, Flex, Text, VStack } from "@chakra-ui/react";
import { NavLink, Outlet } from "react-router-dom";

const SuperRoleLayout = () => {
  const navLinks = [
    { label: "Export Config", to: "/admin/super-role/export-config" },
    { label: "Import Config", to: "/admin/super-role/import-config" },
    { label: "Case Processing", to: "/admin/super-role/case-proccessing" },
  ];

  return (
    <Flex minH="100vh" bg="white">
      <Box
        w="200px"
        boxShadow="md"
        bg="gray.50"
        // p={4}
        borderRight="1px solid"
        borderColor="gray.200"
      >
        <Text fontSize="lg" fontWeight="bold" mb={4} textAlign="center">
          Super User Panel
        </Text>
        <Divider my={2} borderColor="black" />

        <VStack align="stretch" spacing={2}>
          {navLinks.map((link) => (
            <SidebarLink key={link.to} to={link.to} label={link.label} />
          ))}
        </VStack>
      </Box>

      {/* Main content area */}
      <Box flex="1" px={6} mt={2}>
        <Outlet />
      </Box>
    </Flex>
  );
};

export default SuperRoleLayout;

const SidebarLink = ({ to, label }) => {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        display: "block",
        fontWeight: isActive ? "bold" : "normal",
        color: isActive ? "#2B6CB0" : "#1A202C",
        backgroundColor: isActive ? "#E3F2FD" : "transparent",
        padding: "8px 12px",
        // borderRadius: "6px",
        textDecoration: "none",
        transition: "background-color 0.2s ease",
      })}
    >
      <Text>{label}</Text>
    </NavLink>
  );
};
